import { SessionProfileQueryBinding, SessionProfileQuery } from "./session";
import {JSDOM} from 'jsdom';


export class QueryParser
{

    public static getAll(mockWindow: JSDOM | null = null) : Array<SessionProfileQueryBinding>
    {
        // capture form inputs with the matching query markup
        const domQuery = 'input';
        let formInputs: Array<HTMLInputElement> = [];
        if (mockWindow !== null) {
            formInputs = [].slice.call(
                mockWindow.window.document.querySelectorAll(domQuery)
            );
        } else {
            formInputs = [].slice.call(
                document.querySelectorAll(domQuery)
            );
        }
        
        // foreach form input
        let queries = [];
        const regex = new RegExp('<::.+::>');
        for(let i = 0; i < formInputs.length; i ++) {
            const value = formInputs[i].value;
            if (regex.test(value)) {
                const query = QueryParser.extractFromValue(value);
                if (query !== null) {
                    queries.push(
                        {
                            element: formInputs[i],
                            query: query
                        }
                    );
                }
            }
        }
        return queries;
    }

    public static extractFromValue(inputValue: string) : SessionProfileQuery | null
    {
        // remove the tags
        inputValue = inputValue.replace('<SESSION>', '');
        inputValue = inputValue.replace('</SESSION>', '');
        inputValue = inputValue.replace(/<::/, '{');
        inputValue = inputValue.replace(/::>/, '}');
        inputValue = inputValue.replace(/;/g, '"');
        return QueryParser.extract(inputValue);
    }

    public static extract(jsonQuery: string) : SessionProfileQuery | null
    {
        try {
            const query = JSON.parse(jsonQuery);
            const queryIsDefined = typeof(query['attribute']) !== 'undefined';
            const indexIsDefined = typeof(query['index']) !== 'undefined';
            if (queryIsDefined && indexIsDefined) {
                return query;
            }
            return null;    
        } catch (exception) {
            console.error(exception);
            return null;
        }
    }

}